import commandeRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  storageHandler,
  toaster,
  $$commande,
  $$wagon,
) => {
  $transitions.onSuccess({
    entering: commandeRoutes.new.path,
  }, (trans) => {
    if (storageHandler.get('consult.commande.new')) {
      $$commande.data.myCommande = storageHandler.get('consult.commande.new')
    } else {
      $$commande.data.myCommande = $$commande.new()
    }
  })

  $transitions.onBefore({
    from: commandeRoutes.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.commande.new', $$commande.data.myCommande)
      $$commande.data.myCommande = null
    }
  })

  $transitions.onSuccess({
    entering: commandeRoutes.home.path,
  }, async (trans) => {
    try {
      const response = await $$commande.request.getAll()
      $$commande.data.myCommandes = response.commandes
      $$commande.data.mySearchedWagons = []
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: commandeRoutes.home.path,
  }, async (trans) => {
    $$commande.data.myCommandes.splice(0, $$commande.data.myCommandes.length)
  })

  $transitions.onSuccess({
    entering: commandeRoutes.details.path,
  }, async (trans) => {
    const commandeId = $$commande.local.getCurrentId()

    try {
      const myCommande = $$commande.request.getById(commandeId)
      const myWagons = $$wagon.request.getBySearch({ commandeId: commandeId, })

      $$commande.data.myCommande = await myCommande
      $$commande.data.myWagons = (await myWagons).wagons
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: commandeRoutes.details.path,
  }, async (trans) => {
    $$commande.data.myCommande = null
    $$commande.data.myWagons = []
  })

  $transitions.onSuccess({
    entering: commandeRoutes.edit.path,
  }, async (trans) => {
    const commandeId = $$commande.local.getCurrentId()
    try {
      const response = $$wagon.request.getBySearch({ commandeId, })
      const commande = await $$commande.request.getById(commandeId)
      $$commande.data.myCommande = commande
      $$commande.data.myCommande.oldValue = commande.name
      $$commande.data.myWagons = (await response).wagons
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: commandeRoutes.edit.path,
  }, async (trans) => {
    $$commande.data.myCommande = null
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/commande/commande.run.js